export const EVENT_COLOR_DEFAULT = '#DFF3E4';

export const SCHEDULE_MODE_FULL = 'full';
export const SCHEDULE_MODE_MYSELF = 'myself';

export const VIEW_MODE_MONTH = 'month';
export const VIEW_MODE_WEEK = 'week';
export const VIEW_MODE_DAY = 'day';
export const DEFAULT_VIEW_MODE = VIEW_MODE_MONTH;
